import React, { useState } from 'react';
import { ShieldCheck, BadgeCheck, Phone, MessageCircle, Flag, Star } from 'lucide-react';
import { Button } from '../ui/button';
import { useApp } from '../../context/AppContext';
import { useToast } from '../../hooks/use-toast';
import { PAYMENT_METHODS } from '../../data/constants';

export const SellerCard = ({ seller }) => {
  const { t } = useApp();
  return (
    <div className="bg-white rounded-2xl border border-[#EFEAE0] p-6" data-testid="seller-card">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-14 h-14 rounded-full bg-[#0F8B5C] flex items-center justify-center text-white font-bold text-lg">{seller.avatar}</div>
        <div className="min-w-0">
          <div className="flex items-center gap-1">
            <span className="font-bold text-[#1A1A1A] truncate" data-testid="seller-name">{seller.name}</span>
            {seller.verified && <BadgeCheck className="w-4 h-4 text-[#0F8B5C] shrink-0" />}
          </div>
          <div className="flex items-center gap-1 text-xs text-[#7A7468]"><Star className="w-3 h-3 fill-[#F2B441] text-[#F2B441]" /> {seller.rating} · {t('detail.member')} 2023</div>
        </div>
      </div>
      <Button className="w-full bg-[#0F8B5C] hover:bg-[#0A6E47] text-white h-11 mb-2" data-testid="seller-message-button"><MessageCircle className="w-4 h-4 mr-2" /> {t('detail.message')}</Button>
      <Button variant="outline" className="w-full h-11 mb-2" data-testid="seller-call-button"><Phone className="w-4 h-4 mr-2" /> {t('detail.call')}</Button>
      <Button className="w-full bg-[#1A1A1A] hover:bg-[#0A6E47] text-white h-11" data-testid="buy-now-button">{t('detail.buy')}</Button>
      <div className="flex items-center gap-2 mt-4 p-3 rounded-xl bg-[#0F8B5C]/8 text-xs text-[#0A6E47]"><ShieldCheck className="w-4 h-4 shrink-0" /><span>{t('detail.safe')}</span></div>
    </div>
  );
};

export const QuickMessage = ({ sellerName }) => {
  const { t } = useApp();
  const { toast } = useToast();
  const [msg, setMsg] = useState('');
  const send = (e) => {
    e.preventDefault();
    if (!msg.trim()) return;
    toast({ title: t('detail.msgSent'), description: `${t('detail.msgSentDesc')} ${sellerName}.` });
    setMsg('');
  };
  return (
    <form onSubmit={send} className="bg-white rounded-2xl border border-[#EFEAE0] p-5" data-testid="quick-message-form">
      <h3 className="font-bold text-sm text-[#1A1A1A] mb-3">{t('detail.quickQuestion')}</h3>
      <textarea value={msg} onChange={(e) => setMsg(e.target.value)} placeholder={t('detail.quickPlaceholder')} rows={3} data-testid="quick-message-input" className="w-full p-3 rounded-lg border border-[#EFEAE0] text-sm resize-none focus:outline-none focus:ring-2 focus:ring-[#0F8B5C]/30" />
      <Button type="submit" className="w-full mt-2 bg-[#1A1A1A] hover:bg-[#0F8B5C] text-white" data-testid="quick-message-submit">{t('detail.send')}</Button>
    </form>
  );
};

export const PaymentsAccepted = () => {
  const { t } = useApp();
  return (
    <>
      <div className="bg-white rounded-2xl border border-[#EFEAE0] p-5">
        <h3 className="font-bold text-sm text-[#1A1A1A] mb-3">{t('detail.payments')}</h3>
        <div className="flex flex-wrap gap-2">
          {PAYMENT_METHODS.map((p) => <span key={p.id} className="px-2.5 py-1 rounded-lg bg-[#FAF7F2] text-xs font-semibold" style={{ color: p.color }}>{p.name}</span>)}
        </div>
      </div>
      <button className="w-full text-xs text-[#7A7468] hover:text-[#E8814A] flex items-center justify-center gap-1.5 py-2" data-testid="report-listing-button"><Flag className="w-3 h-3" /> {t('detail.report')}</button>
    </>
  );
};
